import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var ReduxCurrentsKey = '__reduxActiveCurrents';
export var injectCurrents = function injectCurrents(state, values) {
  return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, ReduxCurrentsKey, _objectSpread(_objectSpread({}, state[ReduxCurrentsKey]), values)));
};
var barkAtMissingStoreInitialization = function barkAtMissingStoreInitialization() {
  var message = "Attempting to access state provided by 'redux-current', " + 'with no success, maybe you forgot to render ProvideCurrentKey in the react subtree';
  if (process.env.NODE_ENV !== 'production') {
    throw new Error(message);
  }
  // eslint-disable-next-line
  console.warn(message);
};
var blankObj = {};

/**
 * @deprecated use composeCurrentKeySelector instead
 *   selectActiveCurrents is considered deprecated as it reveals implementation details
 */
export var selectActiveCurrents = function selectActiveCurrents(state) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$__dangerouslySup = _ref.__dangerouslySuppressError,
    __dangerouslySuppressError = _ref$__dangerouslySup === void 0 ? false : _ref$__dangerouslySup;
  return state[ReduxCurrentsKey] || !__dangerouslySuppressError && barkAtMissingStoreInitialization() || blankObj;
};
export var composeCurrentKeySelector = function composeCurrentKeySelector(key) {
  return function (state) {
    return selectActiveCurrents(state)[key];
  };
};